import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const ConfigSection = ({ title, icon: Icon, children, collapsible = false, defaultOpen = true }) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    return (
        <div className="bg-white rounded-xl bxshadowhd p-6 overflow-hidden border">
            <div
                className={`flex items-center justify-between ${collapsible ? 'cursor-pointer hover:bg-gray-50 transition-colors' : ''}`}
                onClick={collapsible ? () => setIsOpen(!isOpen) : undefined}
            >
                <div className="flex items-center gap-3">
                    <div className="p-2 bg-congf rounded-lg">
                        <Icon className="iconsw text-white" />
                    </div>
                    <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
                </div>
                {collapsible && (
                    <button
                        className="text-gray-500 hover:text-gray-700 transition-colors"
                        onClick={(e) => {
                            e.stopPropagation();
                            setIsOpen(!isOpen);
                        }}
                    >
                        {isOpen ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
                    </button>
                )}
            </div>
            {(!collapsible || isOpen) && (
                <div className="pb-6 space-y-4 border-gray-100">
                    <div className="pt-6">{children}</div>
                </div>
            )}
        </div>
    );
};

export default ConfigSection;   